module.exports = __webpack_public_path__ + "static/img/introduceContent3.a1a931f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/introduceContent3.png
// module id = Y/b8
// module chunks = 1